// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { LogLevel } from "@lib/logging/LogLevel";

/**
 * Describes the object used for configuring logging.
 */
export type LoggingConfiguration = {
  enabled?: boolean;
  logLevel?: LogLevel;
};